// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseProfitPage_inputContainer__2yESt"};